module.exports = __webpack_public_path__ + "static/img/valve1.05f1da5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/valve/valve/valve1.jpg
// module id = I1uY
// module chunks = 0